import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { useSelector } from 'react-redux'
import clonedeep from 'lodash.clonedeep'

import './styles.scss'
import ModalWrapper from './ModalWrapper'
import { getStaticImage } from 'utils/statics'
import { channelToAdd } from 'constants/channels'
import { canAddChannel } from 'services/PlanRestrictions'
import ModalPlan from 'components/ModalPlan'

const getChannelsToAdd = (currentPlan) => {
  const channels = clonedeep(channelToAdd)

  const aChannels = []
  for (const [key, value] of Object.entries(channels)) {
    aChannels.push({
      label: I18n.t(value.name),
      value: value.key,
      hub: value.hub,
      order: value.order,
      disabled: !canAddChannel(currentPlan, key)
    })
  }

  return aChannels.sort((a, b) => a.order - b.order)
}

const SelectChannel = (props) => {
  const { selectedChannel, isOpen, toggle } = props

  const currentPlan = useSelector(store => store.currentPlan)
  const [channelOptions, setChannelOptions] = useState([])
  const [showPlanModal, setShowPlanModal] = useState(false)

  useEffect(
    () => {
      setChannelOptions(getChannelsToAdd(currentPlan))
    }, [currentPlan]
  )
  const onTogglePlanModal = () => setShowPlanModal(!showPlanModal)

  return (
    <div>
      <ModalWrapper
        id='modalAddChannel'
        header=' '
        showClose
        body={
          <div>
            <h1>{I18n.t('dashboard_add-channel')}</h1>
            <legend>{I18n.t('channels_add_channel_subtitle')}</legend>
            <div className='channel-list-popup'>
              {
                channelOptions.map((it, idx) => (
                  <div
                    key={idx}
                    className={`channel select-${it.value} ${it.disabled ? 'disabled-channel' : ''}`}
                    onClick={
                      () => {
                        if (it.disabled) {
                          onTogglePlanModal()
                        } else {
                          selectedChannel({
                            key: it.value,
                            hub: it.hub,
                            label: it.label
                          })
                        }
                      }
                    }
                  >
                    <img
                      src={`${getStaticImage(`/channels/orange-brand/${it.value}-icon.svg`)}`}
                      alt={`${it.label} channel`}
                    />
                    <span className='channel_list_width_modal_label'>{it.label}</span>
                  </div>
                ))
              }
            </div>
          </div>
        }
        isOpen={isOpen}
        toggle={toggle}
      />

      <ModalPlan
        isOpen={showPlanModal}
        toggle={onTogglePlanModal}
      />
    </div>
  )
}

export default SelectChannel